import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/Venzo-Logo.png.webp'; // Use your actual logo image path

const HomePage = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      background: '#fff',
      alignItems: 'center',
      padding: 0,
    }}>
      <div style={{ height: '40px', width: '100%' }} />
      <div style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <img
          src={logo}
          alt="Venzo Logo"
          style={{
            width: 180,
            height: 180,
            objectFit: 'contain',
            marginBottom: 0,
            display: 'block'
          }}
        />
      </div>
      <button
        onClick={handleGetStarted}
        style={{
          width: '90%',
          maxWidth: 340,
          margin: '0 auto 32px auto',
          padding: '16px 0',
          background: '#111',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          fontWeight: 600,
          fontSize: 16,
          letterSpacing: 1,
          boxShadow: '0 2px 8px 0 rgba(0,0,0,0.09)',
          cursor: 'pointer'
        }}
      >
        GET STARTED
      </button>
    </div>
  );
};

export default HomePage;
